import { useState } from "react"
import { API_ROUTES, userIsLogged, useTitle } from "../../helpers"

export default function House({ activeTab }) {

    useTitle('LMOAPPS - House')

    document.body.className = 'body-house'


    return (
        <>
            <div className="overlay overlay-house"></div>
            <nav className={"navbar navbar-expand navbar-light house-nav"}>
                <div className="container-fluid">
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav m-auto">
                            <a href="./pilotage" className={"nav-link" + ' ' + (activeTab === 'pilotage' ? 'active' : null)}><i className="fa fa-thermometer-half"></i>
                                <span className="d-sm-none">Temp</span>
                                <span className="d-none d-sm-inline">Température</span>
                            </a>
                            <a href="./prog" className={"nav-link" + ' ' + (activeTab === 'prog' ? 'active' : null)}><i
                                className="fa fa-clock-o"></i>
                                <span className="d-sm-none">Prog</span>
                                <span className="d-none d-sm-inline">Programmation</span></a>
                            <a href="./vr" className={"nav-link" + ' ' + (activeTab === 'vr' ? 'active' : null)} ><i
                                className="fa fa-home"></i>
                                <span className="d-sm-none">VR</span>
                                <span className="d-none d-sm-inline">Volets</span></a>
                            <a href="./elec" className={"nav-link" + ' ' + (activeTab === 'elec' ? 'active' : null)}><i
                                className="fa fa-bolt"></i>
                                <span className="d-sm-none">Elec</span>
                                <span className="d-none d-sm-inline">Conso Electrique</span></a>
                        </div>
                    </div>
                </div>
            </nav >
        </>)

}
